<template>
    <div></div>
</template>

<script>
import { tempCodeIssue } from "../../../resources/api/sso.js";

// 남은 전파 대상 / 전파 종료 후 최종 이동지
const QUEUE_KEY = "ssoPropagateQueue";
const RETURN_KEY = "ssoPropagateReturn";

export default {
    name: "SSOPropagate",

    async created() {
        await this.fnNext();
    },

    methods: {
        // 남은 대상이 있으면 하나 거쳐 세션을 만들고, 없으면 최종 목적지로 이동
        async fnNext() {
            let queue = [];
            try {
                queue = JSON.parse(sessionStorage.getItem(QUEUE_KEY) || '[]');
            } catch (e) {
                queue = [];
            }

            if (queue.length === 0) {
                await this.fnFinish();
                return;
            }

            // 실패해도 다시 시도하지 않도록 먼저 큐에서 제외
            const target = queue.shift();
            sessionStorage.setItem(QUEUE_KEY, JSON.stringify(queue));

            try {
                const res = await tempCodeIssue();
                const tempCode = res.data.data;
                const back = window.location.origin + this.$filters.ctxPath('/ssoPropagate.page');

                window.location.href = target.webUrl + '/ssoLogin.page?tempCode=' + tempCode
                    + '&redirectUrl=' + encodeURIComponent(back);
            } catch (error) {
                // 이 대상만 건너뛰고 나머지를 계속 진행
                console.error('로그인 전파 실패:', error, target);
                await this.fnNext();
            }
        },

        // 전파 종료
        async fnFinish() {
            let ret = {};
            try {
                ret = JSON.parse(sessionStorage.getItem(RETURN_KEY) || '{}');
            } catch (e) {
                ret = {};
            }
            sessionStorage.removeItem(QUEUE_KEY);
            sessionStorage.removeItem(RETURN_KEY);

            // 외부 시스템(BI 등) 요청으로 시작된 로그인
            if (ret.type === 'external' && ret.url) {
                try {
                    const res = await tempCodeIssue();
                    const url = new URL(ret.url);
                    url.searchParams.append('tempCode', res.data.data);
                    window.location.href = url.toString();
                    return;
                } catch (error) {
                    console.error('임시코드 발급 실패:', error);
                }
            }

            window.location.href = ret.url || this.$filters.ctxPath('/');
        },
    },
};
</script>

<style scoped></style>
